import server from '../server'


export default {
  data() {
    return {
      news: [], //the list of news
      loading: false, //if list is loading
      error: null //if we got an error on load
    }
  },


  //load on component create
  created(){
    this.load()
  },



  methods:{
    //load employee and day data from the API
    load(){
      this.loading = true
      this.error = null

      server.load()
      .then(result => {
        this.loading = false
        this.news = result.news
      })
      .catch(error => {
        this.loading = false
        this.error = error
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/news/mixins/list.js